module.exports = __webpack_public_path__ + "media/warranty-claim/photos-fasteners2-444788da.png";